import { roleApi } from '@/api/RoleApi'
import { NodeType } from '@/api/types/pt_enums'

import type { RolePrivilegeInfo } from '@/api/types/pt_entities'

export const useMenuStore = defineStore('menu', () => {
  const menus = ref<RolePrivilegeInfo[]>([])
  const menuLeafs = computed(() => {
    const leaves: Record<string, RolePrivilegeInfo> = {}
    function traverse(menuItems: RolePrivilegeInfo[]) {
      for (const item of menuItems) {
        if (item.nodeType === NodeType.LEAF.value) {
          leaves[item.value!] = item
        } else if (item.children && item.children.length > 0) {
          traverse(item.children)
        }
      }
    }
    traverse(menus.value)
    return leaves
  })
  // { path: route.fullPath, title: route.meta.title as string, name: route.name as string }
  const pathItems = ref<Array<{ path: string; title: string; name: string; component: string }>>([])
  const cacheComponents = computed(()=>pathItems.value.map(item=>item.component))
  // const cacheComponents = ref<string[]>([])

  async function loadMenus() {
    menus.value = await roleApi.getSelfPrivileges({ type: 'admin-menu' })
  }

  function updateCurrentItemTitle(title: string) {
    if (pathItems.value.length > 0) {
      pathItems.value[pathItems.value.length - 1]!.title = title
    }
  }

  return {
    menus,
    pathItems,
    menuLeafs,
    cacheComponents,
    loadMenus,
    updateCurrentItemTitle
  }
})
